// Динамический импорт useAuth с обработкой ошибок
let useAuthModule: any = null;
let useAuthLoadError: Error | null = null;
let useAuthLoading = true;

// Пытаемся загрузить модуль при инициализации
import(/* @vite-ignore */ 'auth/useAuth')
  .then((module) => {
    useAuthModule = module;
    useAuthLoading = false;
  })
  .catch((err) => {
    console.warn('[safeUseAuth] Failed to load auth module, will use fallback:', err);
    useAuthLoadError = err;
    useAuthLoading = false;
  });

interface UseAuthResult {
  user?: {
    firstName?: string;
    lastName?: string;
    isEmailVerified?: boolean;
  } | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error?: unknown;
  login: (...args: any[]) => Promise<void>;
  logout: () => Promise<void> | void;
  register: (...args: any[]) => Promise<void>;
  verifyEmail: (token: string) => Promise<void>;
  isUserAuthenticated: () => boolean;
  hasPermission?: (permission: string) => boolean;
  hasRole?: (role: string) => boolean;
}

// Заглушка для случая, когда auth модуль недоступен
const fallbackAuth: UseAuthResult = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  login: async () => {
    console.warn('[safeUseAuth] login called but auth module is unavailable');
  },
  logout: async () => {
    console.warn('[safeUseAuth] logout called but auth module is unavailable');
  },
  register: async () => {
    console.warn('[safeUseAuth] register called but auth module is unavailable');
  },
  verifyEmail: async () => {
    console.warn('[safeUseAuth] verifyEmail called but auth module is unavailable');
  },
  isUserAuthenticated: () => false,
};

/**
 * Безопасный хук useAuth с обработкой ошибок
 * Если модуль auth недоступен, возвращает заглушку
 */
export function safeUseAuth(): UseAuthResult {
  // Если модуль еще загружается
  if (useAuthLoading) {
    return {
      ...fallbackAuth,
      isLoading: true,
    };
  }

  // Если модуль недоступен, возвращаем заглушку
  if (useAuthLoadError || !useAuthModule) {
    return fallbackAuth;
  }

  // Если модуль загружен, используем реальный useAuth
  try {
    const useAuth = useAuthModule.useAuth || useAuthModule.default;
    if (typeof useAuth === 'function') {
      return useAuth();
    }
    return fallbackAuth;
  } catch (err) {
    console.warn('[safeUseAuth] Error calling useAuth, using fallback:', err);
    return fallbackAuth;
  }
}

